import axios from 'axios'

const HTTPInit = axios.create({
  baseURL: process.env.API_URL
})

HTTPInit.defaults.headers.post['Content-Type'] = 'multipart/form-data'

export const HTTPMultipartFormData = HTTPInit



// WEBPACK FOOTER //
// ./src/api/http-multipart-form.js